import { render } from "./Certificado.vue?vue&type=template&id=a85243ca&scoped=true"
import script from "./Certificado.vue?vue&type=script&lang=js"
export * from "./Certificado.vue?vue&type=script&lang=js"

import "./Certificado.vue?vue&type=style&index=0&id=a85243ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85243ca"]])

export default __exports__